<div class="mat-tab-body-fix">
  <div class="container">
    <onsip-full-web-preview-frame-image [width]="width"></onsip-full-web-preview-frame-image>
    <onsip-small-web-preview-frame
      [class.left]="buttonLocation === 'left'"
      [class.right]="buttonLocation === 'right'"
      [buttonLocation]="buttonLocation"
      [buttonColor]="buttonColor"
      [gradientOverlay]="gradientOverlay"
      [removedOnsipBranding]="removedOnsipBranding"
    >
      <ng-content></ng-content>
    </onsip-small-web-preview-frame>
  </div>
</div>
